<template>
    <div class="living">
        <h3 class="live-top flex flex-vertical-center">
            <span class="live-top-title">直播中...</span>
            <span class="live-top-time">{{ week }}</span>
        </h3>
        <div class="live-container flex">
            <div class="living-time">
                <p class="start-time">{{ startTime }}</p>
                <!-- <span class="end-time">{{ endTime }}结束</span> -->
            </div>
            <div class="living-content">
                <div class="content flex flex-between">
                    <div class="flex flex-column">
                        <p class="subjuect">{{ baseData.name }}</p>
                        <span class="teacher">{{
                            `授课老师：${baseData.teacher_name} / 科目：【${baseData.subject_name}】`
                        }}</span>
                        <span class="subscribe-count">{{ data.reserve_count }}人 预约</span>
                    </div>
                    <div class="flex">
                        <hk-button
                            v-if="doTestStatus"
                            text="做作业"
                            :customStyle="buttonStyle2"
                            @handleClick="toTest(baseData.id)"
                        ></hk-button>
                        <hk-button
                            v-if="baseData.work_status > 0"
                            text="查看解析"
                            :customStyle="buttonStyle"
                            @handleClick="toAnalysis(baseData.id)"
                        ></hk-button>
                        <hk-button
                            text="进入直播"
                            class="ml-16"
                            :customStyle="buttonStyle"
                            @handleClick="toLiving"
                        ></hk-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from '@plugins/_moment';
import HkButton from '@components/HkButton';
export default {
    name: 'Living',
    components: {
        HkButton
    },
    props: {
        data: {
            require: true,
            type: [Object, Array]
        },
        baseData: {
            require: true,
            type: Object
        }
    },
    data() {
        return {
            buttonStyle: {
                width: '110px',
                color: '#fff',
                shadowColor: '#FFC8A4',
                background: true,
                startColor: '#FF7B1A',
                endColor: '#FFA11A'
            },
            buttonStyle2: {
                width: '110px',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#A90FBC',
                endColor: '#CA2AD0'
            }
        };
    },

    computed: {
        doTestStatus() {
            const { baseData, data } = this;
            if (
                baseData.work_id > 0 &&
                !baseData.work_status &&
                data.am_i_reserved &&
                data.live_end_time
            ) {
                return true;
            }
            return false;
        },
        week() {
            const showTime = this.baseData.show_time;
            const momentTime = moment(showTime);
            return momentTime.format('dddd');
        },
        startTime() {
            const time = this.data.live_start_time;
            return moment(time).format('HH:mm');
        },
        endTime() {
            const time = this.data.live_end_time;
            return moment(time).format('HH:mm');
        }
    },

    created() {},

    methods: {
        toLiving() {
            const { href } = this.$router.resolve({
                name: 'Video',
                query: { id: this.data.id, scheduleId: this.data.schedule_id }
            });
            this.$trackEvent('直播', '进入直播', this.data.id);
            window.open(href, '_blank');
        },
        toTest(id) {
            this.$trackEvent('答题', '开始做题', id);
            this.$router.push({ name: 'Test', query: { scheduleId: id } });
        },
        toAnalysis(id) {
            this.$trackEvent('答题', '解析', id);
            this.$router.push({ name: 'Analysis', query: { scheduleId: id } });
        }
    }
};
</script>
<style lang="scss" scoped>
.living {
    width: 100%;
    .live-top {
        margin-bottom: 13px;
        span {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #333;
        }
        .live-top-title {
            margin-right: 30px;
        }
    }
    .live-container {
        align-items: flex-start;
        .living-time {
            margin-right: 52px;
            margin-top: 2px;
            width: 78px;
            .start-time {
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 800;
                color: #333;
                margin-bottom: 8px;
            }
            .end-time {
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666;
            }
        }
        .living-content {
            width: calc(100% - 126px);
            padding-left: 12px;
            border-left: 1px solid #e5e5e5;
            .content {
                box-sizing: border-box;
                width: 100%;
                border-radius: 20px;
                background-color: #f9f9f9;
                padding: 20px 20px 20px 36px;
                .subjuect {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 800;
                    color: #333;
                    margin-bottom: 14px;
                }
                .teacher {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #666;
                    margin-bottom: 14px;
                }
                .subscribe-count {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #666;
                }
            }
        }
    }
}
</style>
